<template>
  <el-carousel indicator-position="none" height="800px" @change="change" ref="carousel">
    <el-carousel-item v-for="(item,i) in imglist" :key="item.key" >
      <section class="box bg" v-lazy:background-image="item.imgsrc">
        <section class="container">
          <section :class="['left', {'w-620':item.key==='lunbo2', 'w-520':item.key==='lunbo4'}]">
            <h3>{{item.title}}</h3>
            <strong>{{item.desc1}}</strong>
<!--            <strong>{{item.desc2}}</strong>-->
            <a :class="['btn', item.key]" :href="item.path">查看详情</a>
          </section>
<!--          <section class="right">-->
<!--            <video-->
<!--                :src="item.videoSrc"-->
<!--                muted-->
<!--                loop-->
<!--                controls-->
<!--                :autoplay="showIndex === item.key"-->
<!--                @ended="onVideoEnded"-->
<!--                :ref='"video_"+i'-->
<!--                class="video-bg"-->
<!--            ></video>-->
<!--          </section>-->
          </section>
      </section>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import CountTo from 'vue-count-to'
export default {
  components: { CountTo },
  name: 'wlCarousel',
  props: {
    isNeedInfo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imglist: [
        {
          key: 'lunbo2',
          imgsrc: '/static/img/home/lunbo1.png',
          videoSrc: '/static/img/home/video1.mp4',
          title: '实验室综合管理平台',
          desc1: '对实验室人员、仪器、试剂、危险源、环境等全方位管理 让实验室管理更便捷、更安全',
          path: '/product/synthetical',
        },
        {
          key: 'lunbo1',
          imgsrc: '/static/img/home/lunbo2.png',
          videoSrc: '/static/img/home/video2.mp4',
          title: '实验室智慧管理平台',
          desc1: '深度融合AI算法大模型、物联网技术、数字孪生、大数据分析等 提供“看得清风险、管得住流程、防得住事故”的全场景解决方案',
          path: '/product/wise',
        },
      ],
      showIndex: 0,
      infoList: [
        { title: '专注', desc: '实验室信息化管理' },
        { title: '大', desc: '产品线', startVal: 0, endVal: 3 },
        { title: '年', desc: '实验室信息化服务经验', startVal: 0, endVal: 15 },
        { title: '+', desc: '高校、科研单位的成功选择', startVal: 0, endVal: 300 },
      ],
    }
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.playVideo(this.showIndex)
      })
    }, 1000)
  },
  methods: {
    playVideo(index) {
      const video = this.$refs[`video_${index}`]
      if (video) {
        const el = Array.isArray(video) ? video[0] : video
        el.play().catch(() => {})
      }
    },
    onVideoEnded() {
      // 视频播放结束后自动切换到下一张
      const nextIndex = (this.showIndex + 1) % this.showIndex.length
      this.$refs.carousel.setActiveItem(nextIndex)
    },
    change(e){
      console.log(e);
      this.showIndex = e;
      this.$emit('change', e);
      this.$nextTick(() => {
        const videos = this.$el.querySelectorAll('.video-bg')
        videos.forEach((video, i) => {
          if (i === e) {
            video.play().catch(() => {})
          } else {
            video.pause()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  height: 800px;
  position: relative;
}
.right{
  margin-top: 170px;
  margin-left: 50px;
  transform: translateX(150px);
  video{
    width: 600px;
    height: 500px;
    //background: #fbd6a0;
  }
}
.container {
  height: 800px;

  display: flex;
  .left {
    width: 480px;
    padding-top: 268px;
    z-index: 3;
  }
}

.w-620 {
  //width: 620px !important;

  h3 {
    margin-bottom: 46px;
  }
}

.w-520 {
  width: 520px !important;

  .btn {
    margin-top: 95px;
  }
}

.w-360 {
  width: 360px !important;
}

.btn {
  width: 160px;
  height: 48px;
  background: #F56728;
  box-shadow: 1px 8px 20px 0px rgba(243,69,11,0.4);
  border-radius: 24px;
  font-size: 20px;
  color: #fff;
  line-height: 48px;
  z-index: 4;
  margin-top: 76px;
  display: inline-block;
  text-align: center;
}

strong {
  font-size: 19px;
  display: block;
  color: #6d6d6d;
  line-height: 46px;
  // font-weight: 600;
}

h3 {
  margin-bottom: 40px;
  font-size: 40px;
  line-height: 40px;
  font-weight: bold;
  color: #262626;
}

section {
  text-align: left;
}

.lunbo1 {
  background: #F56728;
}

.lunbo2 {
  background: #F56728;
}

.lunbo3 {
  background: #4472c4;
}
</style>
